import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ta from './locales/ta.json';
import { getStoredTranslateLanguage } from '../utils/googleTranslate';

// Google Translate is the language switch (see utils/googleTranslate). English is the base, so Google always
// translates from the English source. For Tamil we use our own hand-written strings (ta.json) wherever they exist,
// because Google gets short UI words wrong (e.g. "Home" -> "வீடு" (house) instead of "முகப்பு"). Strings missing from
// ta.json fall back to English and are then translated by Google.
localStorage.removeItem('gettimelam_language');

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            ta: { translation: ta },
        },
        lng: getStoredTranslateLanguage() === 'ta' ? 'ta' : 'en',
        fallbackLng: 'en',
        defaultNS: 'translation',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
